import { mapGetters } from 'vuex';
import "core-js/modules/es.array.push.js";
import { defineComponent } from 'vue';
import layout from '@/views/layout/layout.vue';
import Banner from './components/banner.vue';
import Technologies from './components/technologies.vue';
import Steps from './components/steps.vue';
import Comment from './components/comment.vue';
import Print from './components/print.vue';
export default defineComponent({
  name: 'login',
  data() {
    return {};
  },
  components: {
    layout,
    Banner,
    Technologies,
    Steps,
    Comment,
    Print
  },
  computed: {
    ...mapGetters('userInfo', ['isLogin'])
  },
  mounted() {},
  methods: {
    goPage() {
      if (this.isLogin) {
        this.$router.push('/home/index');
      } else {
        this.$store.commit('userInfo/setOpenLoginPanel', true);
      }
    }
  }
});